if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}


document.addEventListener('DOMContentLoaded', function () {

  const form = document.querySelector('form[action^="/cart/add"]');
  const availabilityEl = document.querySelector('.product-form__inventory');

  const variantDataEl = document.getElementById('variant-data');
  if (!variantDataEl || !form) return;

  let variants = [];
  try {
    variants = JSON.parse(variantDataEl.getAttribute('data-variants') || '[]');
  } catch (e) {
    console.error('Variant data JSON parse error', e);
  }

  const variantsById = {};
  variants.forEach(v => (variantsById[String(v.id)] = v));

  // ----------------------------------------------------
  // Ensure hidden fields exist
  // ----------------------------------------------------
  function ensureHiddenProperty(name, id = null) {
    let input = form.querySelector(`input[name="properties[${name}]"]`);
    if (!input) {
      input = document.createElement('input');
      input.type = 'text';
      input.name = `properties[${name}]`;
      if (id) input.id = id;
      form.appendChild(input);
    }
    return input;
  }

  const preorderFlagInput = ensureHiddenProperty('Preorder', 'preorder-flag');
  const preorderTextInput = document.getElementById('preorder-text'); // user created input

  // ----------------------------------------------------
  // Get current variant
  // ----------------------------------------------------
  function getCurrentVariantId() {
    const idInput = form.querySelector('input[name="id"]');
    if (idInput?.value) return idInput.value;

    const select = form.querySelector('select[name="id"]');
    if (select?.value) return select.value;

    return null;
  }

  // ----------------------------------------------------
  // Update UI and input values
  // ----------------------------------------------------
  function updateForVariant(variantId) {
    const addToCartBtn = document.querySelector('.product-form__submit');
    const addToCartBtnText = document.querySelector('.product-form__submit .button-text');
    if (!addToCartBtn || !addToCartBtnText) return;

    const v = variantsById[String(variantId)];
    if (!v) return;

    const isPreorder = Number(v.inventory_quantity) <= 0 && v.inventory_policy === 'continue';
    const preorderText = v.metafields?.custom?.pre_order_text || v.pre_order_text || v.expected_shipping || "";

    // ------------------------------
    // PREORDER
    // ------------------------------
    if (isPreorder) {
      addToCartBtn.disabled = false;
      addToCartBtn.classList.add('is-preorder');
      addToCartBtnText.textContent = 'Preorder';

      if (availabilityEl) availabilityEl.textContent = preorderText;

      preorderFlagInput.value = preorderText;

      // ⭐ Update #preorder-text input with latest flag + inventory
      if (preorderTextInput) {
        preorderTextInput.value = preorderFlagInput.value  ;
      }

      return;
    }

    // ------------------------------
    // IN STOCK
    // ------------------------------
    if (v.available) {
      addToCartBtn.disabled = false;
      addToCartBtn.classList.remove('is-preorder');
      addToCartBtnText.textContent = 'Add to cart';

      preorderFlagInput.value = '';
      if (preorderTextInput) preorderTextInput.value = '';

      if (availabilityEl) availabilityEl.textContent = '';
      return;
    }

    // ------------------------------
    // SOLD OUT
    // ------------------------------
    addToCartBtn.disabled = true;
    addToCartBtn.classList.remove('is-preorder');
    addToCartBtnText.textContent = 'Sold out';

    preorderFlagInput.value = '';
    if (preorderTextInput) preorderTextInput.value = '';
    if (availabilityEl) availabilityEl.textContent = 'Sold out';
  }

  // ----------------------------------------------------
  // Variant change event
  // ----------------------------------------------------
  document.addEventListener('variant:change', function (e) {
    const id = e?.detail?.variant?.id;
    setTimeout(() => updateForVariant(id), 50);
  });

  // Fallback for select/input
  const idInput = form.querySelector('input[name="id"], select[name="id"]');
  if (idInput) {
    idInput.addEventListener('change', function (e) {
      setTimeout(() => updateForVariant(e.target.value), 50);
    });
  }

  // Initial variant
  const initialId = getCurrentVariantId();
  if (initialId) updateForVariant(initialId);
});






